import { render } from "./Info.vue?vue&type=template&id=55c12000"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=55c12000&lang=scss"
script.render = render

export default script